import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import React from "react";
import ReactDOM from "react-dom";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";
import App from "src/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "src/store/store";
import ErrorBoundarys from "src/error/ErrorBoundary";
import { theme } from "src/styles/theme";
import { ThemeProvider } from "styled-components";
import GlobalStyles from "src/styles/GlobalStyles";

const appEnv = process.env.REACT_APP_ENV;

Sentry.init({
  dsn: "https://600ab52ed68a46aa95d9ebf00be313ec@o252899.ingest.sentry.io/6765215",
  environment: appEnv,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(React.useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes),
    }),
  ],
  // integrations: [new Sentry.Integrations.Breadcrumbs({ console: true }), new BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

// const msalInstance = new PublicClientApplication(MSAL_CONFIG);
ReactDOM.render(
  // <MsalProvider instance={msalInstance}>
  // StrictMode는 애플리케이션 내의 잠재적인 문제를 알아내기 위한 도구입니다. 개발 모드
  // <React.StrictMode>
  <React.Fragment>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Sentry.ErrorBoundary>
          <GlobalStyles />
          <App />
        </Sentry.ErrorBoundary>
      </ThemeProvider>
    </Provider>
  </React.Fragment>,
  // {/* </React.StrictMode>, */}
  // </MsalProvider>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
